const ADMIN_ROLES = ["super-admin", "merchant-admin", "merchant-user"];

export default class User {
  constructor(data = {}) {
    this.id = data.id;
    this.username = data.username;
    this.email = data.email;
    this.role = data.role;
    this.name = data.name;
    this.payersList = data.payersList || [];
  }

  get isLoggedIn() {
    return !!(this.id || this.username);
  }

  get isGuest() {
    return !this.isLoggedIn;
  }

  get isAdminRole() {
    return ADMIN_ROLES.includes(this.role);
  }
}
